if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();

        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !window.theme || !theme.cookiesEnabled) {
          return;
        }

        if (!theme.config.isTouch || (window.Shopify && window.Shopify.designMode)) {
          this.init();
        } else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }

      get shouldLock() {
        return true;
      }

      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }

      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay'), 10) : 4;
      }

      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry'), 10) : 14;
      }

      get cookieName() {
        return 'concept:newsletter-popup';
      }

      get submited() {
        return this.querySelector('.alert') !== null;
      }

      init() {
        if (this.initialized) return;
        this.initialized = true;

        // Soporte completo para el editor de temas de Shopify (Theme Customizer)
        if (window.Shopify && window.Shopify.designMode) {
          // Abrir para que el usuario pueda ver la prueba y configurarla en vivo
          setTimeout(() => this.show(), 400);

          document.addEventListener('shopify:section:select', (event) => {
            const section = event.target;
            if (section && (section.contains(this) || (section.id && section.id.includes('newsletter-popup')))) {
              this.show();
            }
          });

          document.addEventListener('shopify:section:load', (event) => {
            const section = event.target;
            if (section && (section.contains(this) || (section.id && section.id.includes('newsletter-popup')))) {
              setTimeout(() => this.show(), 300);
            }
          });

          document.addEventListener('shopify:section:deselect', (event) => {
            const section = event.target;
            if (section && (section.contains(this) || (section.id && section.id.includes('newsletter-popup')))) {
              this.hide();
            }
          });

          document.addEventListener('shopify:block:select', (event) => {
            const target = event.target;
            if (this.contains(target) || (target.closest && (target.closest('#shopify-section-newsletter-popup') || target.closest('[id*="newsletter-popup"]')))) {
              this.show();
            }
          });

          return;
        }

        // Abrir modal si existen mensajes de error o éxito
        if (this.submited) {
          this.load(1);
          return;
        }

        // Modo de prueba o visitante nuevo
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          try { sessionStorage.removeItem(this.cookieName); } catch (e) {}
          this.load(this.delay);
        } else if (!this.getCookie(this.cookieName)) {
          try {
            if (sessionStorage.getItem(this.cookieName)) return;
          } catch (e) {}
          this.load(this.delay);
        }
      }

      load(delay) {
        if (window.Shopify && window.Shopify.designMode) return;

        setTimeout(() => this.show(), Math.max(delay, 0) * 1000);
      }

      afterShow() {
        super.afterShow();
        this.classList.add('show-image');

        // Registrar inmediatamente que ya se mostró para no volver a salir al recargar o cambiar de sección
        if (!this.testMode) {
          this.setCookie(this.cookieName, this.expiry);
          try { sessionStorage.setItem(this.cookieName, 'true'); } catch (e) {}
        }
      }

      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');

        // Eliminar cookie en modo de prueba para que siempre vuelva a salir
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          try { sessionStorage.removeItem(this.cookieName); } catch (e) {}
          return;
        }

        this.setCookie(this.cookieName, this.expiry);
      }

      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }

      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/`;
      }

      removeCookie(name) {
        document.cookie = `${name}=; max-age=0; path=/`;
      }
    }
  );
}
